var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6515_44340)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6515_44340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5359 8.53912L9.83427 2.00907L9.38507 1.57114C9.28272 1.47201 9.14431 1.41638 9.00004 1.41638C8.85577 1.41638 8.71736 1.47201 8.61501 1.57114L1.46418 8.53912C1.3593 8.64097 1.27642 8.76226 1.22042 8.89585C1.16442 9.02944 1.13643 9.17261 1.13812 9.31691C1.14506 9.91209 1.65323 10.3872 2.26373 10.3872H3.00084V15.8943H14.9992V10.3872H15.752C16.0485 10.3872 16.3278 10.2739 16.5376 10.0693C16.641 9.96892 16.7228 9.84952 16.7785 9.71804C16.8342 9.58656 16.8625 9.44562 16.862 9.30339C16.862 9.01594 16.7458 8.74371 16.5359 8.53912V8.53912ZM9.97129 14.6769H8.02879V11.2276H9.97129V14.6769ZM13.7505 9.16981V14.6769H11.0813V10.8218C11.0813 10.4481 10.7708 10.1454 10.3875 10.1454H7.61254C7.22924 10.1454 6.91879 10.4481 6.91879 10.8218V14.6769H4.24959V9.16981H2.58459L9.00177 2.91874L9.40241 3.30933L15.4172 9.16981H13.7505Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6515_44340",
    x: -0.861954,
    y: 0.416382,
    width: 19.7239,
    height: 18.4779,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.435294 0 0 0 0 1 0 0 0 0 0.00392157 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6515_44340"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6515_44340",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6515_44340"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.119995,
    width: 17.76,
    height: 17.3143,
    rx: 1,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.9d52a8d2.svg";
export { ForwardRef as ReactComponent };